/**
 * Utility functions for the Pay It Furward referral program.
 */

/**
 * Email provider configurations for the referral email.
 *
 * Each provider has a different URL format for composing emails:
 * - Gmail: Uses query params with 'view=cm' for compose mode
 * - Outlook: Uses deeplink/compose endpoint
 * - Default: Falls back to mailto: protocol (opens system default)
 */
export const EMAIL_PROVIDERS = {
  gmail: {
    name: "Gmail",
    buildUrl: (subject, body) =>
      `https://mail.google.com/mail/?view=cm&fs=1&to=&su=${encodeURIComponent(
        subject,
      )}&body=${encodeURIComponent(body)}`,
  },
  outlook: {
    name: "Outlook",
    buildUrl: (subject, body) =>
      `https://outlook.live.com/mail/0/deeplink/compose?subject=${encodeURIComponent(
        subject,
      )}&body=${encodeURIComponent(body)}`,
  },
  default: {
    name: "My Mail App",
    buildUrl: (subject, body) =>
      `mailto:?subject=${encodeURIComponent(
        subject,
      )}&body=${encodeURIComponent(body)}`,
  },
};

/**
 * Builds the referral email subject and body content.
 */
export function getReferralEmailContent(referralLink, userName) {
  const subject = "Have you tried Scribenote?";

  const body = `Hey!

I've been using Scribenote to finish my notes way faster, and I thought of you. They have a referral program that gives both of us $200 for patient care if you end up liking it.

Here's my link to sign up:
${referralLink}

${userName}`;

  return { subject, body };
}

/**
 * Builds a referral email URL for a specific provider.
 */
export function buildReferralEmailUrl(
  provider,
  referralLink,
  userName,
) {
  const { subject, body } = getReferralEmailContent(
    referralLink,
    userName,
  );
  const providerConfig =
    EMAIL_PROVIDERS[provider] || EMAIL_PROVIDERS.default;
  return providerConfig.buildUrl(subject, body);
}
